// extracted by mini-css-extract-plugin
module.exports = {"box":"Page_box__2nPNz"};